import type { ValidationError } from "class-validator";
import { SITE_TEXTS_BOOT_LOCALE } from "@Front/Stores/siteTextsBootConfig";
import { useSiteTextContent } from "@Front/Stores/SiteTextsContext";
import { buildStepEmailSiteTextsDisplay } from "./stepEmailSiteTextsDisplay";

/**
 * Site texts for StepEmail UI (only keys consumed by this step).
 */
export function useStepEmailSiteTexts(): ReturnType<typeof buildStepEmailSiteTextsDisplay> {
	const locale = SITE_TEXTS_BOOT_LOCALE;
	const welcomeTitle = useSiteTextContent("login.header.title");
	const welcomeSubtitle = useSiteTextContent("login.header.subtitle");
	const ssoProSectionTitle = useSiteTextContent("login.section.ssoPro.title");
	const ssoProCta = useSiteTextContent("login.section.ssoPro.cta");
	const ssoOauthLoginPresetSectionTitle = useSiteTextContent("login.section.ssoOauthLoginPresets.title");
	const clientsSectionTitle = useSiteTextContent("login.section.clients.title");
	const emailPlaceholder = useSiteTextContent("login.form.email.placeholder");
	const emailLabel = useSiteTextContent("login.form.email.label");
	const submitCta = useSiteTextContent("login.form.submit");
	return buildStepEmailSiteTextsDisplay({
		locale,
		welcomeTitle,
		welcomeSubtitle,
		ssoProSectionTitle,
		ssoProCta,
		ssoOauthLoginPresetSectionTitle,
		clientsSectionTitle,
		emailPlaceholder,
		emailLabel,
		submitCta,
	});
}

export type StepEmailSiteTexts = ReturnType<typeof useStepEmailSiteTexts>;

export type StepEmailOuterProps = {
	onSubmit: (e: React.FormEvent<HTMLFormElement> | null, values: { [key: string]: string }) => void;
	validationErrors: ValidationError[];
};
